<template>
    <div style="width: 100%;height: 100%;"
         v-loading="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading">
      <monitor-detail ref="detailMon" style="width: 100%"></monitor-detail>
      <div style="width: 100%;height: 100%" >
        <el-row style="height: 11rem">
          <el-col :span="24">
<!--            <div class="showSearch" style="padding: 2rem 2rem;">-->
            <el-header style="margin:1rem 0 1rem 0;">
              <tab-switch :button-names-arr="tabArr" @curTabButtonClickDeal="onTypeChange"></tab-switch>
            </el-header>
              <!--              <el-button @click="onTypeChange('SPPR')" :class="activeButton === 'SPPR' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>渗流水位</el-button>
              <el-button @click="onTypeChange('PZWL')" :class="activeButton === 'PZWL' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>测压管水位</el-button>
              <el-button @click="onTypeChange('ST')" :class="activeButton === 'ST' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>应变</el-button>
              <el-button @click="onTypeChange('SRHRDS')" :class="activeButton === 'SRHRDS' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>水平位移</el-button>
              <el-button @click="onTypeChange('SRVRDS')" :class="activeButton === 'SRVRDS' ? 'activeButton' : 'normalButton'" type="primary" size="small" round>垂直位移</el-button>

            </div>-->
          </el-col>
          <el-col :span="24">
              <div class="showSearch">
                <el-input
                    placeholder="测点编号"
                    size="small"
                    v-model="mpnm"
                    style="width: 25.4rem;margin-left: 2rem;"
                >
                </el-input>
<!--                <el-input
                    placeholder="水工建筑物"
                    v-model="hycnnm"
                    size="small"
                    class="searhInput"
                >
                </el-input>-->
                <span style="font-family: 'PingFang SC';margin-left: 2rem;margin-right: 1rem;height: 3.2rem;display: flex;align-items: center;font-size: 1.4rem;justify-content: center">时间</span>
                <el-date-picker
                    size="small"
                    v-model="dateTime"
                    type="datetimerange"
                    range-separator="到"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    class="searchDate"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm"
                    :clearable="false"
                >
                </el-date-picker>
                <el-button  class="searchButton" type="info"  size="small"  style="width: 8.3rem" @click="reset">
                  重置
                </el-button>
                <el-button type="primary" size="small" class="searchButton"  icon="el-icon-search" style="width: 10.6rem" @click="queryData">
                  查询
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    class="queryButton queryButtonPadding qDcBtn"
                    @click="download">
                  <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                  &nbsp;导出
                </el-button>
              </div>
          </el-col>
        </el-row>
        <el-row ref="dataShowRow" style="height: calc(100% - 13rem);margin: 0 2rem">
        <el-col :span="12" style="height: 100%;padding-top: 1.5rem">
          <div class="showData" ref="dataDiv">
            <el-table
                  sortable
                :data="tableData"
                highlight-current-row
                height="calc(100% - 4rem)"
                @current-change="handleCurrentChange"
                border
                size="small"
                  ref="monitorSingleTable"
                  :header-cell-style="cellHeadStyle"
                  class="basic">
              <el-table-column
                  property="mpcd"
                  label="测点编号"
                  align="center"
                  :min-width="mpcdWidth"
              >
                <template slot-scope="scope">
                  <span style="cursor: pointer; color: rgb(70, 173, 245);" @click="onDetailShow(scope.row.mpcd)">{{scope.row.mpcd}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  property="mstm"
                  label="时间"
                  align="center"
                  :min-width="mstmWidth"
              >
              </el-table-column>
                <el-table-column
                    v-for="(item,index) in columns"
                    :key="item.property+'-'+index"
                    :property="item.property"
                    :label="item.label"
                    :min-width="item.width"
                >
                  <template slot-scope="scope">
                    <span :style="{'width':'100%','display': 'flex','justify-content':'flex-end','color': scope.row[item.property] ?
                    item.trend ?
                      scope.row[item.trend] ?
                      scope.row[item.trend] > 0 ?
                      '#fd1553' :
                      scope.row[item.trend] < 0 ?
                      '#15bffd' : '#000' : '#000'
                      :'#000'
                      :'#000'}"
                    >{{ scope.row[item.property] ? scope.row[item.property] : '' }}</span>
                  </template>
                </el-table-column>
              </el-table>
            <div class="pageStyle">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handlePageChange"
                  :page-sizes="[ 20, 30, 40, 50, 100]"
                  :page-size="params.size"
                  :current-page="params.current"
                  layout="total, prev, pager, next,sizes, jumper"
                  :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </el-col>

          <point-detail ref="pointDetail" style="z-index: 1;"></point-detail>
        <el-col :span="12" style="height:100%;padding-top: 1.5rem;padding-left: 1rem;position: relative;z-index: 0">
          <div style="position: absolute;top: 30px;left: 20px;z-index: 1;">
            <el-tooltip content="回到中心点" placement="bottom" effect="light">
              <img src="@/assets/images/ysqjc/sxwz.png" style="cursor: pointer;" @click="sxwz">
            </el-tooltip>
          </div>
          <div ref="monitorShow" style="height:100%;width: 100%;" ></div>
        </el-col>
      </el-row>
      </div>
    </div>
</template>
<script setup>
import MonitorDetail from "./monitorDetail";
import {dateTimeToString} from "../../utils/dateUtils";
import * as THREE from "../../utils/basejs/three.min";
import {OrbitControls} from "@/utils/basejs/OrbitControls";
import {
  addGroup,
  addLine,
  addPoint,
  addTextGroup,
  addThings,
  clearSection,
  clearText,
  removeTextGroup
} from "./js/things";
import TabSwitch from "../../components/buttonGather/tabSwitch";
// import { LineMaterial } from "@/utils/basejs/LineMaterial";
// import { addShape, addSvg, dfFont } from "@/utils/basejs/addThreeThings";
import {TWEEN} from "@/utils/basejs/tween.module.min";
import PointDetail from "./pointDetail";
import {clearScene} from "../../utils/basejs/addThreeThings";

  let renderer = null;
  let scene = null;
  let camera = null;
  let controls = null;
  /*const columnTypes = {
        'SPPR':[{'property': 'spprwl',label: '渗流压力水位',width: '',needTreed:true,lineColor: '#5470C6',dw:'',bh: 'dataList1',yPosition:'left',chartType: 'line'},
          {'property': 'rwater',label: '实际水深',width: '',needTreed:false,lineColor: '#91CC75',dw:'',bh: 'dataList2',yPosition:'left',chartType: 'line',offset: 42},
          {'property': 'wt',label: '温度（℃）',width: '',lineColor: '#FAC858',needTreed:false,bh: 'wtList',yPosition:'right',chartType: 'line',dw:''}],
        'PZWL':[{'property': 'pztbwl',label: '测压管水位',width: '',needTreed:true,lineColor: '#5470C6',bh: 'dataList1',yPosition:'left',chartType: 'line',dw:''},
          {'property': 'wt',label: '温度（℃）',width: '',needTreed:false,lineColor: '#FAC858',bh: 'wtList',yPosition:'right',chartType: 'line',dw:''}],
        'ST':[{'property': '',label: '应变',width: '',needTreed:true,lineColor: '#5470C6',bh: 'dataList1',yPosition:'left',chartType: 'line',dw:''},
          {'property': '',label: '温度（℃）',width: '',needTreed:false,lineColor: '#FAC858',bh: 'wtList',yPosition:'right',chartType: 'line',dw:''}],
        'SRHRDS':[{'property': 'xhrds',label: 'X向水平位移',width: '',needTreed:true,lineColor: '#5470C6',bh: 'dataList1',yPosition:'left',chartType: 'line',dw:''},
          {'property': 'yhrds',label: 'Y向水平位移',width: '',needTreed:true,lineColor: '#91CC75',bh: 'dataList2',yPosition:'right',chartType: 'line',dw:''}],
        'SRVRDS':[{'property': 'vrds',label: '垂直位移',width: '',needTreed:true,lineColor: '#5470C6',bh: 'dataList1',yPosition:'left',chartType: 'line',dw:''}],
      };*/
  const columnGrid = {
    '0601': {
      // show: true,
      left: '5%',
      right: '5%',
      bottom: '4%',
      top: '10%',
      containLabel: true
    },
    '0602':{
      // show: true,
      left: ' 5%',
      right: '5%',
      bottom: '4%',
      top: '10%',
      containLabel: true
    },
    '0603':{
      // show: true,
      left: ' 5%',
      right: '5%',
      bottom: '4%',
      top: '10%',
      containLabel: true
    },
    '0604':{
      // show: true,
      left: ' 5%',
      right: '5%',
      bottom: '4%',
      top: '10%',
      containLabel: true
    },
    '0605':{
      // show: true,
      left: ' 5%',
      right: '5%',
      bottom: '4%',
      top: '10%',
      containLabel: true
    },
    '0606':{
      // show: true,
      left: ' 5%',
      right: '5%',
      bottom: '4%',
      top: '10%',
      containLabel: true
    }

  };
  const columnTypes =
      {
        '0601': [
          {
            property: 'rwater',
            label: '实际水深(m)',
            width: 110,
            trend: false,
            lineColor: '#2c83ea',
            lineColorStop: 'rgba(0,218,252,0)',
            dw: '',
            bh: 'dataList2',
            yPosition: 'left',
            chartType: 'line',
            offset: 80,
            needChart: false
          },
          {
            property: 'tbbtel',
            label: '管底高程(m)',
            width: 110,
            trend: false,
            lineColor: '#2c83ea',
            lineColorStop: 'rgba(0,218,252,0)',
            dw: '',
            bh: 'dataList2',
            yPosition: 'left',
            chartType: 'line',
            offset: 80,
            needChart: false
          },

        {
          property: 'pztbwl',
          label: '测压管水位(m)',
          width: 110,
          trend: 'trend',
          lineColor: '#5470C6',
          lineColorStop: 'rgba(0,218,252,0)',
          bh: 'dataList1',
          yPosition: 'left',
          chartType: 'line',
          dw: '',
          needChart: true,
          needMaxMin: 'sw'
        },

          {
            property: 'wt',
            label: '温度(℃)',
            width: 110,
            trend: false,
            lineColor: '#FAC858',
            lineColorStop: 'rgba(0,218,252,0)',
            bh: 'wtList',
            yPosition: 'right',
            chartType: 'line',
            dw: '',
            needChart: true,
          }],
        '0602':
            [
              //   {'property': 'spprwl',label: '渗流压力水位(m)',width: '16.47%',needTreed:true,lineColor: '#00dcfe',lineColorStop: 'rgba(0,218,252,0)',dw:'',bh: 'dataList1',yPosition:'left',chartType: 'line'},
              // {'property': 'rwater',label: '实际水深(m)',width: '13.13%',needTreed:false,lineColor: '#2c83ea',lineColorStop: 'rgba(0,218,252,0)',dw:'',bh: 'dataList2',yPosition:'left',chartType: 'line',offset: 42},
              // {'property': 'wt',label: '温度（℃）',width: '12.9%',lineColor: '#FAC858',lineColorStop: 'rgba(0,218,252,0)',needTreed:false,bh: 'wtList',yPosition:'right',chartType: 'line',dw:''}],
              {
                property: 'spprwl',
                label: '渗流压力水位(m)',
                width: 110,
                trend: 'trend',
                lineColor: '#5470C6',
                lineColorStop: 'rgba(0,218,252,0)',
                dw: '',
                bh: 'dataList1',
                yPosition: 'left',
                chartType: 'line',
                needChart: true,
                needMaxMin: 'sw'
              },
              {
                property: 'wt',
                label: '温度(℃)',
                width: 114,
                lineColor: '#FAC858',
                lineColorStop: 'rgba(0,218,252,0)',
                trend: false,
                bh: 'wtList',
                yPosition: 'right',
                chartType: 'line',
                dw: '',
                needChart: true,
              }]
        , '0603':
            [{
              property: 'stn',
              label: '应变(10⁻⁶)',
              width: 155,
              trend: 'trend',
              lineColor: '#5470C6',
              lineColorStop: 'rgba(0,218,252,0)',
              bh: 'dataList1',
              yPosition: 'left',
              chartType: 'line',
              dw: '',
              needChart: true,
            },
              {
                property: 'wt',
                label: '温度(℃)',
                width: 114,
                trend: false,
                lineColor: '#FAC858',
                lineColorStop: 'rgba(0,218,252,0)',
                bh: 'wtList',
                yPosition: 'right',
                chartType: 'line',
                dw: '',
                needChart: true
              }]
        , '0604':
            [{
              property: 'xhrds',
              label: 'X向水平位移(mm)',
              width: 150,
              trend: 'xtrend',
              lineColor: '#5470C6',
              lineColorStop: 'rgba(0,218,252,0)',
              bh: 'dataList1',
              yPosition: 'left',
              chartType: 'line',
              dw: '',
              needChart: true
            },]
        , '0605':
            [{
              property: 'yhrds',
              label: 'Y向水平位移(mm)',
              width: 150,
              trend: 'ytrend',
              lineColor: '#5470C6',
              lineColorStop: 'rgba(0,218,252,0)',
              bh: 'dataList2',
              yPosition: 'left',
              chartType: 'line',
              dw: '',
              needChart: true
            }],
        '0606':
            [{
              property: 'vrds',
              label: '垂直位移(mm)',
              width: 150,
              trend: 'trend',
              lineColor: '#5470C6',
              lineColorStop: 'rgba(0,218,252,0)',
              bh: 'dataList1',
              yPosition: 'left',
              chartType: 'line',
              dw: '',
              needChart: true
            }]
      };
  const headWidth = {
    // {mpcd: '13.36%',mpnm: '11.86%',hycnnm: '11.86%',mstm: '20.4%'},
    '0601': {mpcd: 116,mstm: 177},
    '0602': {mpcd: 116,mstm: 206},
    '0603':{mpcd: 116,mstm: 206},
    '0604':{mpcd: 135,mstm: 260},
    '0605': {mpcd: 135,mstm: 260},
    '0606':{mpcd: 135,mstm: 260}
  }
  export default {
    components: {PointDetail, TabSwitch, MonitorDetail},
    data() {
      return {
        grid: {},
        tabArr:[],
        activeButton: '0601',
        hycnnm: '',
        mpnm: '',
        mpcdWidth: 0,
        mstmWidth: 0,
        // hycnnmWidth: 0,
        // mpnmWidth: 0,
        tableData: [],
        currentRow: null,
        dateTime: [],
        columns: [],
        currentColumns : [],
        tableMaxHeight: null,
        constDateTime: [],
        params:{current: 1,size: 20},
        total: 0,
        requestID: null,
        loading:false,
        currentActives: [],
        raycaster: new THREE.Raycaster(),
        rescd: '',
        pointDetailShow: false,
        tmpPoint: null,
        clickPoint: null,
      }
    },
    created() {
      const now = new Date();
      // const now = new Date(2021,3,1);
      // const start = new Date(2021,0,1)
      const start = new Date(now.getTime() - 30*24*3600000);
      // const start = new Date(now.getFullYear(),now.getMonth(),now.getDay(),0,0,0);
      // const nowStr = dateTimeToString(now,true);
      const nowStr = dateTimeToString(now,true);
      const startStr = dateTimeToString(start,true);

      this.dateTime = [startStr,nowStr];
      this.constDateTime = [startStr,nowStr];
    },
    mounted() {
      this.queryTypes();

    },
    beforeDestroy() {

      if (this.requestID) {
        try {
          // camera.dispose();
          clearScene(scene);

          // scene.background.dispose();
          controls.dispose();
          this.mousePointer = null;
          scene.remove();
          scene.clear();
          scene = null;
          this.raycaster = null;
          const gl = renderer.domElement.getContext('webgl');
          gl && gl.getExtension("WEBGL_LOSE_CONTEXT").loseContext();
          TWEEN.removeAll();
          renderer.renderLists.dispose();
          renderer.dispose();
          renderer.forceContextLoss();
          renderer.domElement = null;
          renderer.content = null;
          camera = null;
          renderer = null;
          cancelAnimationFrame(this.requestID);
          THREE.Cache.clear();
          this.timeDiv.removeEventListener("click", this.onMouseClick, true);
          this.timeDiv.removeEventListener("mousemove", this.onMouseMove, true);
          // renderer.forceContextLoss();
          // renderer.content = null;
        }catch (e){
          console.log(e);
        }
      }
      /*if (this.websocket) {
        this.websocket.close();
      }*/
      // this.timeDiv.removeEventListener("click", this.onMouseClick, true);
      window.removeEventListener("resize",this.onWindowResize);
      window.onresize = null;
    },
    methods: {
      download(){
        const params = {
          mstp: this.activeButton,
          // mpcdnm: this.mpcd,
          mstmGE: this.dateTime[0],
          mstmLE: this.dateTime[1]
        };
        this.request.get('/rm-rpzwl/v1/export',{ params: params,responseType: "blob" }).then((res) => {
          try {
            let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
            a.click();
            URL.revokeObjectURL(a.href);
            return;
          } catch (error) {
            const reader = new FileReader();
            reader.readAsText(res.data, 'utf-8');
            let _this = this;
            reader.onload = function () {
              const msg = JSON.parse(reader.result);
              if (!msg.ok) {
                if (msg.error.code === 3001) {
                  _this.$message.error(msg.error.message);
                } else {
                  _this.$message.warning(msg.error.message);
                }
              }
            }
          }
        });
      },
      positionChange(worldPosition){
          const screenPosition = new THREE.Vector3();
          screenPosition.copy(worldPosition)
              .project(camera)
          const a = this.timeDiv.offsetWidth * 0.5;
          const b = this.timeDiv.offsetHeight * 0.5;
          const c = this.timeDiv.offsetHeight * 0.75
          // const x = Math.round(screenPosition.x * a + )
          const x = (screenPosition.x * a) + a;
          const y = -(screenPosition.y * b) + b;
          const tableDiv = this.$refs.dataDiv;
          const tableDivWidth = tableDiv.offsetWidth;
          const pointWidth = 260;
          const width1 = tableDivWidth + 40;
          const width2 = tableDivWidth - pointWidth - 40;
          const length = x + width1 + pointWidth;
          const dataShowRowWidth = this.$refs.dataShowRow.$el.offsetWidth;
          if(length > dataShowRowWidth){
            // if(y > c) {
            //   return {x: width2 + x, y: y};
            // }else {
            //
            // }
            return {x: width2 + x, y: y};
          }else {
            return {x: width1 + x, y: y};
          }

      },
      queryTypes(){
        this.request.get('/rm-bmp/queryMstpListByRescd').then((res)=> {
              if(res.ok){
                const data = res.data;
                if(data) {
                  this.rescd = data.rescd;
                  const mstps = data.mstps;
                  const mstpNames = [];
                  const columnsDatas = [];
                  const actives = [];
                  for (let d of mstps) {
                    mstpNames.push(d.mstpNm);
                    actives.push(d.mstp);
                    const column = columnTypes[d.mstp];
                    if(column){
                      columnsDatas.push(column);
                    }
                  }
                  this.currentActives = actives;
                  this.tabArr = mstpNames;
                  this.currentColumns = columnsDatas;
                  this.onTypeChange(0);
                  if(!this.requestID){
                    this.threeInit();
                  }
                }
              }else {
                this.$message.error(res.error.message);
              }
            }

        );
      },
      cellHeadStyle(row,column,rowIndex, columnIndex){
        return {backgroundColor:'#f9f9ff',fontSize: '1.6rem',textAlign:'center',color:'#323232',
          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh',padding:0}
      },
      filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },
      animate() {
        this.requestID = requestAnimationFrame(this.animate);
        controls.update();
        // this.render();
        TWEEN.update();
        this.cameraRange();
        renderer.render(scene, camera);

      },
      threeInit() {
        this.timeDiv = this.$refs.monitorShow;
        camera = new THREE.PerspectiveCamera(
            80,
            this.timeDiv.offsetWidth / this.timeDiv.offsetHeight,
            1,
            12000
        );
        // camera.position.set(0, 30, 0);
        camera.position.set(970,500,950);
        renderer = new THREE.WebGLRenderer({antialias: true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(
            this.timeDiv.offsetWidth,
            this.timeDiv.offsetHeight
        );
        renderer.antialias=true;
        renderer.alpha=true;
        this.timeDiv.append(renderer.domElement);
        scene = new THREE.Scene();
        scene.background = new THREE.Color('#FFF');
        controls = new OrbitControls(
            camera,
            renderer.domElement
        );
        controls.enableRotate = false;
        controls.autoRotate = false;
        controls.minDistance = 200;
        controls.maxDistance = 1000;
        // controls.target0.set(800, 400, 0);
        controls.target.set(970, 500, 0);

        controls.mouseButtons = {
          LEFT: THREE.MOUSE.PAN,
          MIDDLE: THREE.MOUSE.DOLLY,
          RIGHT: THREE.MOUSE.ROTATE,
        };
        // this.requestID = requestAnimationFrame(this.animate);
        // addOverAll(secondGroup);
        // addModel(thirdGroup);
        // this.initBall();
        // this.initModel();
        // window.addEventListener("resize", this.onWindowResize, false);
        // this.timeDiv.addEventListener("mousemove", this.onMouseMove, true);
        // this.timeDiv.addEventListener("click", this.onMouseClick, true);
        // const clock = new THREE.Clock();
        // let time = 0;
        addThings();
        addGroup(scene);
        this.animate();
        this.timeDiv.addEventListener("click", this.onMouseClick, true);
        this.timeDiv.addEventListener("mousemove", this.onMouseMove, true);
        this.onWindowResize();
        window.addEventListener("resize", this.onWindowResize, false);
        /*controls.addEventListener('change',()=>{
            if(camera.position.x < 600){
              if(camera.position.y < 425) {
                controls.target.set(600, 425, controls.target.z);
                camera.position.set(600, 425, camera.position.z);
              }else if(camera.position.y > 690){
                controls.target.set(600, 690, controls.target.z);
                camera.position.set(600, 690, camera.position.z);
              }else{
                controls.target.set(600,controls.target.y,controls.target.z);
                camera.position.set(600,camera.position.y,camera.position.z);
              }
            }else
              if(camera.position.x > 1200){
                if(camera.position.y < 425) {
                  controls.target.set(1200, 425, controls.target.z);
                  camera.position.set(1200, 425, camera.position.z);
                }else if(camera.position.y > 690){
                  controls.target.set(1200, 690, controls.target.z);
                  camera.position.set(1200, 690, camera.position.z);
                }else{
                  controls.target.set(1200,controls.target.y,controls.target.z);
                  camera.position.set(1200,camera.position.y,camera.position.z);
                }
              }else{
                if(camera.position.y < 425) {
                  controls.target.set(controls.target.x, 425, controls.target.z);
                  camera.position.set(camera.position.x, 425, camera.position.z);
                }else if(camera.position.y > 690){
                  controls.target.set(controls.target.x,690, controls.target.z);
                  camera.position.set(camera.position.x, 690, camera.position.z);
                }else{
                  controls.saveState();
                }
              }
        });*/
      },
      cameraRange(){
        if(camera.position.x < 400){
          if(camera.position.y < 425) {
            controls.target.set(400, 425, controls.target.z);
            camera.position.set(400, 425, camera.position.z);
          }else if(camera.position.y > 690){
            controls.target.set(400, 690, controls.target.z);
            camera.position.set(400, 690, camera.position.z);
          }else{
            controls.target.set(400,controls.target.y,controls.target.z);
            camera.position.set(400,camera.position.y,camera.position.z);
          }
        }else
        if(camera.position.x > 1600){
          if(camera.position.y < 425) {
            controls.target.set(1600, 425, controls.target.z);
            camera.position.set(1600, 425, camera.position.z);
          }else if(camera.position.y > 690){
            controls.target.set(1600, 690, controls.target.z);
            camera.position.set(1600, 690, camera.position.z);
          }else{
            controls.target.set(1600,controls.target.y,controls.target.z);
            camera.position.set(1600,camera.position.y,camera.position.z);
          }
        }else{
          if(camera.position.y < 425) {
            controls.target.set(controls.target.x, 425, controls.target.z);
            camera.position.set(camera.position.x, 425, camera.position.z);
          }else if(camera.position.y > 690){
            controls.target.set(controls.target.x,690, controls.target.z);
            camera.position.set(camera.position.x, 690, camera.position.z);
          }else{
            controls.saveState();
          }
        }
        if(camera.position.z < 500){
          addTextGroup();
        }else {
          removeTextGroup();
        }
      },
      handleSizeChange(size){
        this.params.size = size;
        this.queryData();
      },
      handlePageChange(page){
        this.params.current = page;
        this.queryData();
      },
      sxwz() {
        const position = {x: 970, y: 500, z: 950};
        this.animateCamera(position);
        if(this.tmpPoint){
          this.tmpPoint.material.color.set('#3F00FF');
          this.tmpPoint = null;
        }
        if(this.clickPoint){
          this.clickPoint.material.color.set('#3F00FF');
          this.clickPoint = null;
        }
        this.setCurrent();
      },
      reset(){
        this.dateTime = this.constDateTime;
        this.mpnm = '';
        this.params.size = 20;
        this.params.current = 1;
        // camera.position.set(950,500,1000);
        // controls.target.set(950, 500, 0);
        this.queryData();
      },
      onWindowResize(){
        // this.timeDiv = this.$refs.monitorShow;
        const width = this.timeDiv.offsetWidth;
        const height = this.timeDiv.offsetHeight;
        camera.aspect = width / height;
        renderer.setSize(width,height);
        camera.updateProjectionMatrix();
        renderer.setPixelRatio(window.devicePixelRatio);
      },
      queryData(){
        const startTime = new Date(this.dateTime[0]);
        const endTime = new Date(this.dateTime[1]);
        if(startTime.getTime() + 3600000 * 24 * 365 < endTime.getTime()){
          this.$message.warning('查询时间间隔需小于一年！');
          return;
        }
        const params = {mstp: this.activeButton,mstmGE:this.dateTime[0],mstmLE:this.dateTime[1],current: this.params.current,size: this.params.size};
        if(this.mpnm){
          params.mpcdnm = this.mpnm;
        }
        if(this.hycnnm){
          params.hycnnm = this.hycnnm;
        }
        /*let urlParams = '?aqjclx='+this.activeButton+'&mstmGE='+this.dateTime[0]+'&mstmLE='+this.dateTime[1];
        if(this.mpnm){
          urlParams = '&mpcdnm='+this.mpnm;
        }
        if(this.hycnnm){
          urlParams = '&hycnnm='+this.hycnnm;
        }*/
        if(this.tmpPoint) {
          this.tmpPoint.material.color.set('#3F00FF');
          this.tmpPoint = null;
        }
        if(this.clickPoint) {
          this.clickPoint.material.color.set('#3F00FF');
          this.clickPoint = null;
        }
        this.loading = true;
        this.request.post('/rm-rpzwl/queryAqjcPage', params).then((res)=> {
          if(res.ok){
                this.tableData = res.data.records;
                this.total = res.data.total;
                this.loading = false;
                this.sxwz();
              }else {
                this.$message.error(res.error.message);
              }
            }
        );
        clearText();
        if(this.activeButton === '0601'){
          this.querySection();
        }else {
          clearSection();
        }
        this.queryPoint();
      },
      querySection(){
        this.request.get('/rm-bsection/querySectionCoordinate').then((res)=> {
              if(res.ok){
                const data = res.data;
                addLine(data);
              }else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      queryPoint(){
        const params = {mstp: this.activeButton};
        if(this.mpnm){
          params.mpcdnm = this.mpnm;
        }
        this.request.get('/rm-bmp/queryMpCoordinate/',{params: params}).then((res)=> {
              if(res.ok){
                const data = res.data;
                addPoint(data);
                this.onWindowResize();
              }else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      onMouseMove(event) {
        const pointer = { x: null, y: null };
        pointer.x = (event.offsetX / this.timeDiv.offsetWidth) * 2 - 1;
        pointer.y = -(event.offsetY / this.timeDiv.offsetHeight) * 2 + 1;
        this.raycaster.setFromCamera(pointer, camera);
        const points = scene.getObjectByName('mps');
        const intersects = this.raycaster.intersectObjects(
            points.children
        );
        if (intersects.length > 0) {
          if(this.pointDetailShow){
            return;
          }
          this.$refs.monitorShow.style.cursor = 'pointer';
          const object = intersects[0].object;
          if(this.tmpPoint) {
            this.tmpPoint.material.color.set('#3F00FF');
          }
          this.tmpPoint = object;
          object.material.color.set('#3CB371');
          const params = {mstp: this.activeButton,mstmGE:this.dateTime[0],mstmLE:this.dateTime[1],mpcd: object.bh};
          // this.$refs.pointDetail.changeData(data);
          // const tableDiv = this.$refs.dataDiv;
          // const position1={x: event.offsetX + tableDiv.offsetWidth + 20,y: event.offsetY};
          this.request.post('/rm-rpzwl/queryMsData', params).then((res)=> {
              if(res.ok){
                const position = this.positionChange(object.position);
                if(!res.data){
                  const data = {mpcd: object.bh,
                    mstm: this.dateTime[1].substring(0,16),
                    data1: null,
                    data2: null,
                    wt: null,}
                  this.$refs.pointDetail.positionChange(true,position,this.activeButton,data);
                  this.pointDetailShow = true;
                  // this.$refs.pointDetail.positionChange(false,position,this.activeButton,{});
                  return;
                }
                let da = res.data;
                da.mstm = da.mstm.substring(0,16);
                const data = {...da,mpcd: object.bh};
                this.$refs.pointDetail.positionChange(true,position,this.activeButton,data);
                this.pointDetailShow = true;
              }else {
                this.pointDetailShow = false;
                this.$refs.pointDetail.positionChange(false,position,this.activeButton,{});
              }
          });
        }else{
          if(this.tmpPoint){
            if(this.clickPoint && this.clickPoint.bh === this.tmpPoint.bh){
              this.tmpPoint.material.color.set('#7FFFD4');
            }else {
              this.tmpPoint.material.color.set('#3F00FF');
            }
            this.tmpPoint = undefined;
          }
          this.pointDetailShow = false;
          this.$refs.pointDetail.positionChange(false,{},this.activeButton,{});
          this.$refs.monitorShow.style.cursor = 'auto';
        }
      },
      onMouseClick(event) {
        const pointer = { x: null, y: null };
        pointer.x = (event.offsetX / this.timeDiv.offsetWidth) * 2 - 1;
        pointer.y = -(event.offsetY / this.timeDiv.offsetHeight) * 2 + 1;
        this.raycaster.setFromCamera(pointer, camera);
        /*const screenPoint = new THREE.Vector3();
        const worldPoint = new THREE.Vector3();
        screenPoint.x = pointer.x;
        screenPoint.y = pointer.y;
        screenPoint.z = 0;
        screenPoint.unproject(camera);
        screenPoint.sub(camera.position).normalize();
        const distance = -camera.position.z / screenPoint.z;
        worldPoint.copy(camera.position).add(screenPoint.multiplyScalar(distance));
        console.log(worldPoint);*/

        const points = scene.getObjectByName('mps');
        const intersects = this.raycaster.intersectObjects(
            points.children
        );
        if(intersects.length > 0){
          const object = intersects[0].object;
          this.onDetailShow(object.bh);
          // this.$refs.monitorSingleTable.setCurrentRow(this.tableData.find(n => n.mpcd === object.bh));
        }
      },
      setCurrent(row) {
          this.$refs.monitorSingleTable.setCurrentRow(row);
      },
      animateCamera(position){
        if(camera){
          const tween = new TWEEN.Tween(camera.position).to(position,1000).easing(TWEEN.Easing.Sinusoidal.InOut)
              .onUpdate((res)=>{
                camera.lookAt(res.x,res.y,0);
                controls.target.set(res.x,res.y,0);
              });
          tween.start();
        }
      },
      onDetailShow(mpcd){
        if(this.pointDetailShow){
          this.pointDetailShow = false;
          this.$refs.pointDetail.positionChange(false,{},this.activeButton,{});
        }
        this.$refs.detailMon.initColumns(this.columns, this.activeButton, mpcd, this.dateTime,this.grid);
        window.removeEventListener("resize", this.onWindowResize);
      },
      handleCurrentChange(val) {
        if(val){
          this.currentRow = val;
          const mpcd = val.mpcd;
          const pointGroup = scene.getObjectByName('mps');
          if(pointGroup && pointGroup.children.length > 0){
            pointGroup.traverse(n => {
              if(n.bh && n.bh === mpcd){
                if(this.clickPoint){
                  this.clickPoint.material.color.set('#3F00FF');
                }
                this.clickPoint = n;
                n.material.color.set('#7FFFD4');
                const x = n.position.x;
                const y = n.position.y;
                const target = {x:x,y:y,z:400};
                this.animateCamera(target);
                controls.target.set(x,y,0);
              }
            });
          }
        }

        /*if(val) {
          const dataDiv = this.$refs.tableDiv;
          const max = dataDiv.offsetHeight;
          this.currentRow = val;
          this.detailShow = true;
          this.$refs.detailMon.initColumns(this.columns, val.mpnm, this.activeButton, val.mpcd, max, this.dateTime);
          window.removeEventListener("resize", this.onWindowResize);
        }else {
          this.queryData();
        }*/
      },
      onTypeChange(type){
        /*this.activeButton = type;
        this.columns = columnTypes[type];
        this.queryData();*/
        // if(type){

          const active = this.currentActives[type];
          this.activeButton = active;
          this.columns = this.currentColumns[type];
          const widths = headWidth[active];
          this.mpcdWidth = widths.mpcd;
          this.params.current = 1;
          this.params.size = 20;
          // this.mpnmWidth = widths.mpnm;
          this.mstmWidth = widths.mstm;
          this.grid = columnGrid[active];
          // this.hycnnmWidth = widths.hycnnm;
          this.queryData();

        // }
      }
    },
    watch: {
      "$store.state.head.skCd"() {
        this.queryTypes();
      }
    }
}
</script>
<style scoped>
  .basic{
    width: 100%;
    height: 100%;
  }
  .showSearch{
    display: flex;
    flex-direction: row;
  }
  .searhInput{
    width: 14.8rem;
    margin-left: 1rem;
  }
  .searchDate{
    width: 36rem;
  }
  .searchButton{
    margin-left: 1.5rem;

  }
  .showData{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #FFFFFF;
  }
  .activeButton{
    background-color: #409EFF;
    border-color: #409EFF;
    width: 9.2rem;
  }
  .normalButton{
    background-color: #ecf5ff;
    border-color: #b3d8ff;
    color: #409eff;
    width: 9.2rem;
  }
  .pageStyle{
    height: 3.2rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .tableDiv{
    width: 100%;
    height: calc(100% - 3.5rem);
  }
  .el-table .head-row{
        background-color:#f9f9ff;
        font-size: 1.6rem;
        text-align: center;
        color: #323232;
        font-family: PingFang SC;
        font-weight: normal;
        font-stretch: normal;
        height: 6.5vh
  }

  /* 按钮样式 */
  ::v-deep .queryButton {
    font-family: PingFang SC;
    font-size: 1.4rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    border-radius: 0.5rem;
    margin-left: 1.5rem;
  }

  ::v-deep .queryButtonPadding {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  ::v-deep .qDcBtn {
    position: absolute;
    right: 4rem;
  }

  ::v-deep .qDcImg {
    width: 1.2rem;
    height: 1.2rem;
  }
  ::v-deep .el-table .el-table__body tr.current-row > td{
    background-color: #F0F0FC; /* 自定义颜色 */
    /*color: #FFFFFF;*/
  }

</style>
